import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

/** Recherche au-dessus d'une liste : émet le texte après une courte pause de saisie, ou tout de suite quand on l'efface. */
@Component({
    selector: 'dmp-list-search',
    templateUrl: './list-search.component.html',
    styleUrls: ['./list-search.component.scss'],
    standalone: false
})
export class ListSearchComponent implements OnDestroy {
    @Input() placeholder = '';
    @Output() search = new EventEmitter<string>();

    value = '';
    private timer: ReturnType<typeof setTimeout>;

    onInput(value: string): void {
        this.value = value;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search.emit(this.value.trim()), 300);
    }

    clear(): void {
        clearTimeout(this.timer);
        this.value = '';
        this.search.emit('');
    }

    ngOnDestroy(): void {
        clearTimeout(this.timer);
    }
}
